import React from "react";
import {authRoles} from "app/auth/index.js";

import i18next from "../../../i18n.js";

import en from "./i18n/en.js";
import fr from "./i18n/fr.js";

i18next.addResourceBundle("en", "home", en);
i18next.addResourceBundle("fr", "home", fr);

const homeConfig = {
  settings: {layout: {config: {}}},
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: "/",
      exact: true,
      component: React.lazy(() => import("./HomePage.js")),
    },
  ],
};

export default homeConfig;
